module.exports = __webpack_public_path__ + "static/buzz-saw-04e8673bdb79d0bbdaf2f2a758d0c55f.svg";